var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-285134e8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["disabled", "href", "onClick"];
var _hoisted_2 = {
    key: 0,
    class: "e-button__spinner animate-spin",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
}, null, -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    class: "opacity-75",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_5 = [
    _hoisted_3,
    _hoisted_4
];
var _hoisted_6 = ["disabled", "type"];
var _hoisted_7 = {
    key: 0,
    class: "e-button__spinner animate-spin",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
}, null, -1); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    class: "opacity-75",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_10 = [
    _hoisted_8,
    _hoisted_9
];
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false,
}, { __name: 'EButton', props: {
        type: { default: 'primary' },
        nativeType: { default: 'button' },
        size: { default: 'medium' },
        loading: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        glass: { type: Boolean, default: false },
        transparent: { type: Boolean, default: false },
        hrefTo: { default: null }
    }, emits: ['click', 'mousedown'], setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var sizeClass = computed(function () { return 'e-button--' + props.size; });
        var typeClass = computed(function () { return 'e-button--' + props.type; });
        var onClick = function (e) {
            if (props.disabled || props.loading) {
                return;
            }
            emit('click', e);
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_ctx.hrefTo !== null)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.hrefTo,
                    custom: ""
                }, {
                    default: _withCtx(function (_a) {
                        var href = _a.href, navigate = _a.navigate;
                        return [
                            _createElementVNode("a", _mergeProps(_ctx.$attrs, {
                                class: [[
                                        typeClass.value,
                                        sizeClass.value,
                                        {
                                            'e-button--loading': _ctx.loading,
                                            'e-button--disabled': _ctx.disabled,
                                            'e-button--glass': _ctx.glass,
                                            'e-button--transparent': _ctx.transparent
                                        }
                                    ], "e-button"],
                                disabled: _ctx.disabled,
                                href: href,
                                onClick: function ($event) { return ([onClick($event), navigate($event)]); },
                                onMousedown: _cache[0] || (_cache[0] = function ($event) { return (emit('mousedown', $event)); })
                            }), [
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
                                    : _createCommentVNode("", true),
                                _renderSlot(_ctx.$slots, "default")
                            ], 16, _hoisted_1)
                        ];
                    }),
                    _: 3
                }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("button", _mergeProps({ key: 1 }, _ctx.$attrs, {
                    class: [[
                            typeClass.value,
                            sizeClass.value,
                            {
                                'e-button--loading': _ctx.loading,
                                'e-button--disabled': _ctx.disabled,
                                'e-button--glass': _ctx.glass,
                                'e-button--transparent': _ctx.transparent
                            }
                        ], "e-button"],
                    disabled: _ctx.disabled,
                    type: _ctx.nativeType,
                    onClick: onClick,
                    onMousedown: _cache[1] || (_cache[1] = function ($event) { return (emit('mousedown', $event)); })
                }), [
                    (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "default")
                ], 16, _hoisted_6));
        };
    } }));
